<wr-base-dialog status="danger"
                header="Konzern löschen"
                submitText="Löschen"
                [disableSubmit]="blocked">
  @if (blocked) {
    <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
               status="warning"
               message="Diesem Konzern sind noch Firmen zugeordnet — bitte weise sie zuerst einem anderen Konzern zu.">
    </wr-banner>
  } @else {
    <p>Konzern «{{ groupName }}» wirklich löschen?</p>
  }
</wr-base-dialog>
